import { useQuery } from '@tanstack/react-query';
import { resolveStorageUrl } from '../lib/storage/resolve-storage-url';

export function useStorageUrl(
    value: string | null | undefined,
    bucket: string,
) {
    const query = useQuery({
        queryKey: ['storage-url', bucket, value],
        queryFn: () => resolveStorageUrl(value!, bucket),
        enabled: Boolean(value),
        staleTime: 50 * 60 * 1000,
        gcTime: 60 * 60 * 1000,
        // Signed URL creation can race auth refresh on cold start
        retry: 2,
        retryDelay: (attempt) => 500 * (attempt + 1),
    });

    return {
        url: query.data ?? null,
        isLoading: query.isLoading,
        error: query.error,
    };
}
